import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';
import { SvgHappyGlen } from '../../../icons';
import css from './empty-page.module.scss';

interface EmptyPageProps {
  label: string;
  noDescription?: boolean;
}

export function EmptyPage({ label, noDescription }: EmptyPageProps) {
  const { t } = useTranslation();

  return (
    <Fragment>
      <h1 className={css.label}>{label}</h1>
      <div className={css.container}>
        <SvgHappyGlen />
        {noDescription ? null : (
          <>
            <h2 className={css.heading}>{t('page:empty_heading')}</h2>
            <p className={css.description}>{t('page:empty_description')}</p>
          </>
        )}
      </div>
    </Fragment>
  );
}
